import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const RH = ({match}) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/commission`}/>
        <Route path={`${match.url}/commission`} component={asyncComponent(() => import('./routes/Commission'))}/>
        <Route component={asyncComponent(() => import('../extraPages/routes/404'))}/>
      </Switch>
    </div>
  );
}

export default RH;
